export default __webpack_public_path__ + "static/media/check-small-inactive.838e7a73.svg";